import { useContext } from 'react';

import LuzmoContext from './LuzmoContext';

export default function useLuzmo() {
  return useContext(LuzmoContext);
}
